import { createContext, useContext, useEffect, useState } from "react";
import { api, API_BASE } from "./api";
import { DEFAULT_CONTENT, deepMerge } from "./content";

const SiteContext = createContext(null);

const EMPTY = { content: DEFAULT_CONTENT, services: [], plans: [], faqs: [], testimonials: [], loaded: false };

export function SiteProvider({ children }) {
  const [site, setSite] = useState(EMPTY);

  useEffect(() => {
    if (!API_BASE) {
      setSite((s) => ({ ...s, loaded: true }));
      return undefined;
    }
    let alive = true;
    api
      .get("/public/site")
      .then(({ data }) => {
        if (!alive) return;
        const list = (v) => (Array.isArray(v) ? v : []);
        setSite({
          content: deepMerge(DEFAULT_CONTENT, data?.content ?? {}),
          services: list(data?.services),
          plans: list(data?.plans),
          faqs: list(data?.faqs),
          testimonials: list(data?.testimonials),
          loaded: true,
        });
      })
      .catch(() => {
        if (alive) setSite((s) => ({ ...s, loaded: true }));
      });
    return () => {
      alive = false;
    };
  }, []);

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext) ?? EMPTY;
